import useBanksList from 'hooks/use-banks-list';
import { CEF_CODE } from 'pages/bank-account/constants';
import * as T from 'prop-types';
import { useTranslation } from 'react-i18next';
import InputLabelError from 'utils/old-ui-commons/input-label-error';

import { Box, Flex } from '@olist/united';

import { bankAccountFormFields } from '../schema';
import { ReadOnlyField } from './read-only-field';

export const AccountAndDigitInputs = ({ accountType, selectedBank }) => {
  const { t } = useTranslation();

  const { defaultPlaceholders } = useBanksList();

  const isCEF = selectedBank?.value === CEF_CODE;

  return (
    <Flex flexDirection="row" mb={4} width={[1, 1, '75%', '82%', '65%']}>
      {isCEF && (
        <Box width="25%" mr={3}>
          <ReadOnlyField label={t`operation`} value={accountType?.value} />
        </Box>
      )}
      <Box width={isCEF ? `50%` : `60%`} mr={3}>
        <span aria-label={t`account number`}>
          <InputLabelError
            label={t`account nº`}
            name={bankAccountFormFields.BANK_ACCOUNT}
            placeholder={selectedBank?.accountPlaceholder || defaultPlaceholders.account}
          />
        </span>
      </Box>
      <Box width={isCEF ? `25%` : `40%`}>
        <InputLabelError
          label={t`account digit`}
          name={bankAccountFormFields.BANK_ACCOUNT_DIGIT}
          placeholder="0"
          showMessages={false}
        />
      </Box>
    </Flex>
  );
};

AccountAndDigitInputs.propTypes = {
  accountType: T.shape({
    value: T.string,
  }),
  selectedBank: T.shape({
    value: T.string,
    accountPlaceholder: T.string,
  }),
};

AccountAndDigitInputs.defaultProps = {
  accountType: {},
  selectedBank: {},
};
